/* ============================================================
   Cattle Cams — mobile sticky action bar + tap-to-call linkify
   ------------------------------------------------------------
   Pure ADDITIONS, scoped to phones only:
   1. A sticky bottom bar (Build Yours + click-to-call) that is
      display:none above 760px (see mobile.css) — so desktop is
      never rendered with it.
   2. Turns the desktop nav phone span and the footer phone text
      into tel: links, but ONLY while the viewport is mobile, so
      the desktop DOM/rendering is left exactly as-is.
   Works on BOTH the React pages (index/build) and the static
   HTML pages (parts/story/support/videos).
   ============================================================ */
(function () {
  var PHONE_DISPLAY = "(605) 622-0676";
  var PHONE_HREF = "tel:6056220676";
  var MOBILE_Q = window.matchMedia("(max-width: 760px)");

  /* ---------- 1. Sticky bottom action bar ---------- */
  function buildBar() {
    if (document.querySelector(".cc-actionbar")) return;
    var bar = document.createElement("div");
    bar.className = "cc-actionbar";
    bar.setAttribute("role", "navigation");
    bar.setAttribute("aria-label", "Quick actions");
    bar.innerHTML =
      '<a class="cc-ab-call" href="' + PHONE_HREF + '" aria-label="Call Cattle Cams at ' + PHONE_DISPLAY + '">' +
        '<span class="cc-ab-ico" aria-hidden="true">\u260E</span>' +
        '<span class="cc-ab-stack"><span class="cc-ab-k">Call us</span><span class="cc-ab-v">' + PHONE_DISPLAY + '</span></span>' +
      '</a>' +
      '<a class="cc-ab-build" href="/pages/build">Build Yours <span class="cc-ab-arr" aria-hidden="true">\u2192</span></a>';
    document.body.appendChild(bar);
  }

  /* ---------- 2. Mobile-only tel: linkify ---------- */
  // Remember originals so we can fully restore the desktop DOM on resize-up.
  var linkified = [];

  function linkifyPhones() {
    // (a) Desktop nav phone span -> tel link (keeps the same look)
    var spans = document.querySelectorAll(".cc-nav-phone");
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      if (span.dataset.ccTel === "1") continue;
      if (span.tagName === "A") continue;
      var a = document.createElement("a");
      a.className = span.className + " cc-tel";
      a.href = PHONE_HREF;
      a.textContent = span.textContent;
      a.dataset.ccTel = "1";
      span.parentNode.replaceChild(a, span);
      linkified.push({ link: a, original: span });
    }

    // (b) Footer bottom line: "Call (605) 622-0676 · sales@..."
    // Wrap just the number in a tel link without altering surrounding text.
    var footSpans = document.querySelectorAll(".cc-foot-bottom span");
    for (var j = 0; j < footSpans.length; j++) {
      var fs = footSpans[j];
      if (fs.dataset.ccTel === "1") continue;
      if (fs.querySelector("a.cc-tel")) continue;
      if (fs.textContent.indexOf(PHONE_DISPLAY) === -1) continue;
      fs.dataset.ccTel = "1";
      fs.dataset.ccOriginal = fs.innerHTML;
      var html = fs.innerHTML;
      var safe = PHONE_DISPLAY.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      fs.innerHTML = html.replace(
        new RegExp(safe),
        '<a class="cc-tel" href="' + PHONE_HREF + '">' + PHONE_DISPLAY + "</a>"
      );
    }
  }

  function unlinkifyPhones() {
    // Restore nav spans
    for (var i = 0; i < linkified.length; i++) {
      var rec = linkified[i];
      if (rec.link.parentNode) rec.link.parentNode.replaceChild(rec.original, rec.link);
    }
    linkified = [];
    // Restore footer html
    var footSpans = document.querySelectorAll('.cc-foot-bottom span[data-cc-tel="1"]');
    for (var j = 0; j < footSpans.length; j++) {
      var fs = footSpans[j];
      if (typeof fs.dataset.ccOriginal === "string") fs.innerHTML = fs.dataset.ccOriginal;
      delete fs.dataset.ccTel;
      delete fs.dataset.ccOriginal;
    }
  }

  function applyMobileState() {
    if (MOBILE_Q.matches) linkifyPhones();
    else unlinkifyPhones();
  }

  function init() {
    buildBar();
    applyMobileState();
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  // React navs/footers mount after Babel — re-run linkify as they appear.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (MOBILE_Q.matches) linkifyPhones();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 8000);
  }

  // Switch cleanly between mobile/desktop on resize or rotate.
  if (MOBILE_Q.addEventListener) MOBILE_Q.addEventListener("change", applyMobileState);
  else if (MOBILE_Q.addListener) MOBILE_Q.addListener(applyMobileState);
})();
